export default "__VITE_ASSET__DvzGit77__"